import {
  Component
} from 'src/utils';
import backIcon from './../../../images/back.png';
import menuIcon from './../../../images/menu.png';
import logo from './../../../images/logo-s.png';
import cart from './../../../images/cart.png';
import shopLogo from './../../../images/app-logo.png';
import deleteIcon from './../../../images/delete.png';
import searchIcon from './../../../images/search.png';
import houseIcon from './../../../images/house-icon.png';
import dscCard from './../../../images/WBU-DSC-card.jpg';
import template from './header.html';
import cartIcon from './../../../images/cart-icon.png';
import Headertext from './../../../images/header-text.png';
import StoreIcon from './../../../images/store-icon.png';
import higlightedmarkerIcon from './../../../images/wbu-pointer.png';
import markerIcon from './../../../images/wbu-map-pointer.png';
import dropDown from './../../../images/dropDown.png';


@Component({
  controllerAs: 'header',
  template
})

export default class HeaderContainer {
  static $inject = [
    '$rootScope',
    '$scope',
    '$ngRedux',
    '$window',
    '$state',
    '$uibModal',
    '$interval',
    '$aside',
    'authService',
    'orderService',
    '$cookies',
    '$location',
    '$timeout',
    '$stateParams',
    'toaster',
    'APP',
    'spinnerService'
    
  ];

  constructor($rootScope, $scope, $ngRedux, $window, $state,
    $uibModal, $interval, $aside, $auth, $order, $cookies, $location, $timeout, $stateParams,toaster,  APP, $spinner) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$window = $window;
    this.$aside = $aside;
    this.$uibModal = $uibModal;
    this.$order = $order;
    this.$interval = $interval;
    this.$state = $state;
    this.$spinner = $spinner;
    this.backIcon = backIcon;
    this.menuIcon = menuIcon;
    this.Headertext = Headertext;
    this.logo = logo;
    this.$cookies = $cookies;
    this.$location = $location;
    this.cart = cart;
    this.cartIcon = cartIcon;
    this.StoreIcon = StoreIcon;
    this.APP = APP;
    this.dropDown = dropDown;
    this.myData = "Logo";
    this.templateUrl = 'login.html';
    this.popoverTriggerOption = "outsideClick";
    this.deleteIcon = deleteIcon;
    this.searchIcon = searchIcon;
    this.shopLogo = shopLogo;
    this.promosliderClass = "";
    this.promotionText = "";
    this.promosliderClass = "";
    this.nextIndex = 0;
    this.$stateParams = $stateParams;
    this.markerIcon = markerIcon;
    this.higlightedmarkerIcon = higlightedmarkerIcon;
    this.toaster = toaster;
    this.isMiscelleneousCategory = 4;
    this.hasBirdbuckCoupons = false;
    // this.popovercontent = subCategories;


    this.navStates = [{
        current: 'home',
        heading: 'Welcome'
      },
      {
        current: 'cart',
        heading: 'My Cart'
      },
      {
        current: 'guestCart',
        heading: 'Guest Cart'
      },
      {
        current: 'guestdelivery',
        heading: 'Guest Checkout'
      },
      {
        current: 'profile',
        heading: 'Profile Setting'
      },
      {
        current: 'profile.edit',
        heading: 'Profile Setting'
      },
      {
        current: 'category',
        heading: 'Choose Category'
      },
      {
        current: 'sub-category',
        heading: 'Choose Sub-Category'
      },
      {
        current: 'product',
        heading: 'Choose Product'
      },
      {
        current: 'product.detail',
        heading: 'Product Detail'
      },
      {
        current: 'store-detail',
        heading: 'Store Details'
      },
      {
        current: 'delivery',
        heading: 'Delivery'
      },
      {
        current: 'delivery.address',
        heading: 'Delivery Address'
      },
      {
        current: 'settings',
        heading: 'Settings'
      },
      {
        current: 'terms-conditions',
        heading: 'Terms and Conditions'
      },
      {
        current: 'rules-faq',
        heading: 'Rules / FAQ'
      },
      {
        current: 'faq-birds-critters',
        heading: 'Birds & Critters'
      },
      {
        current: 'faq-franchising',
        heading: 'Franchising'
      },
      {
        current: 'faq-product-warranties',
        heading: 'Product Warranties'
      },
      {
        current: 'privacy',
        heading: 'Privacy'
      },
      {
        current: 'card-detail',
        heading: 'Card Detail'
      },
      {
        current: 'payment.success',
        heading: 'Confirmed'
      },
      {
        current: 'payment.failure',
        heading: 'Failed'
      },
      {
        current: 'recent-order',
        heading: 'Your Orders'
      },{
        current: 'accessibility',
        heading: 'Accessibility Statement'
      }
    ];
    this.$auth = $auth;
    this.$timeout = $timeout;
    if ($stateParams.storeName && $stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      this.storeName = $stateParams.storeName;
    } else {
      this.storeName = this.$auth.getGuestStoreDetail().storeName;
    }
    if (this.storeName && !$auth.isLoggedIn()) {
      $auth.getStoreDetail(this.storeName).then(success => {
          let store = {};
          store.storeId = success.data.storeId;
          store.storeName = this.storeName;
          $auth.doGuestLogin(store);
          if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
            this.$order.getCategories();
            this.$order.getTiles();
          }
          var storeId = null;
          this.guestStore = $auth.getGuestStoreDetail();



          let guestStore = null;
          if ($auth.isGuestLogin()) {
            try {
              guestStore = sessionStorage.getItem('guestStoreName');
            } catch (e) {
              guestStore = $cookies.get('guestStoreName');
            }
            if (!this.profile.store.storeId) {
              this.$auth.getStoreDetail(guestStore).then(success => {
                // console.log(success);
                this.getPromos(success.storeId);
              });
            } else {
              this.getPromos(this.profile.store.storeId);
            }
            $auth.getGuestCart();
          }
        },
        error => {
          // console.log(error);
          // this.$state.go('login');
          // this.$state.go('login');
       /*   let store = {};
          store.storeId = '';
          store.storeName = 'shop';
          $auth.doGuestLogin(store);
          if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
            this.$order.getCategories();
          }
          this.getPromos(store.storeName);*/
            this.$state.go('category', {
            storeName:'' 
      });
      });
    } else if (!this.storeName && !$auth.isLoggedIn()) {
      let store = {};
      store.storeId = '';
      store.storeName = '';
      $auth.doGuestLogin(store);
      $auth.getGuestCart();
      if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
        this.$order.getCategories();
        this.$order.getTiles();
      }
      this.getPromos(store.storeName);
    } else {

      $auth.getUserProfile().then(() => {
        this.getPromos(this.profile.store.storeId);
      });

      $auth.getBBDetails().then(success => {
        console.log("BB details ", success.data);
        if(success && success.data){
          this.hasBirdbuckCoupons = success.data.hasBirdbucks;
        }
        
      });
      // Commented for UI Issue
      this.checkIdleTime = this.checkIdleTime.bind(this);
      this.sessionTimeout();
      this.templateUrl = 'menu.html';
      this.popoverTriggerOption = 'focus';
      if (!this.$stateParams.categoryId || this.subCategories.length == 0) {
        this.$order.getCategories();
        this.$order.getTiles();
      }

    }

    var listener1 = $rootScope.$on('guestLoginConfirmed', () => this.guestLoginConfirmed());
    var listener2 = $rootScope.$on('closeSideNav', () => $rootScope.asideInstance.close());
    var listener3 = $rootScope.$on('onLoginSuccess', () => this.toggleHeader());
    var listener4 = $rootScope.$on('forbidden', () => this.gotToHome());
    var listener5 = $rootScope.$on('onStoreSelection', () => this.toggleHeaderGuest());
    // eslint-disable-next-line arrow-parens
    var listener6 = $rootScope.$on('loginFromPopup', ($event, data) => this.loginFromPopup(data));
    $scope.$on('$destroy', () => {
      $interval.cancel(this.stopCheckIdleTime);
      disconnect();
      listener1();
      listener2();
      listener3();
      listener4();
      listener5();
      listener6();
    });



  }


  mapState(state) {
    let obj = {
      profile: state.auth.profile,
      subCategories: state.order.categories,
      tiles: state.order.tiles,
      products: state.order.products,
      productDetail: state.order.productDetail,
      cartDetail: state.order.cartDetail,
      promo: state.order.promoImage,
      guestCartCount: state.auth.guestCartList && state.auth.guestCartList.length && state.auth.guestCartList.filter(data => !data.isDscCard).length ? state.auth.guestCartList.filter(data => !data.isDscCard).map(data => data.quantity).reduce((total, data) => total + data) : 0
    };

    if (!obj.profile.store) {
      obj.profile = {
        'store': state.auth.storeDetail
      };
    }
    return obj;

  }

  openStoreSelector() {
    this.$rootScope.$emit('onStoreSelection');
    let msg = 'Text';
    var $ctrl;
    $ctrl = this;
    $ctrl.higlightedmarkerIcon = this.higlightedmarkerIcon;
    $ctrl.markerIcon = this.markerIcon;
    this.$uibModal.open({
      size: 'lg',
      template: '<div class="modal-body p-1-1 store_selector_modal" id="modal-body" > <b>Store Selector</b> <div class="pull-right" ng-click="cancel()">close</div><hr class="store-hr">' +
        '<div class="row">' +
        '<div class="col-md-3 p-l-0 p-r-0">' +
        '<div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div style="padding: 0;">' +
        '<form class="input-group" style="text-align: center;padding: 3px;">' +
        '<input type="text"  placeholder="Search by city, state or zip" ng-model="zipcode"  class="form-control" style="background: #ffffff; border-color: rgb(193, 191, 191) !important; height:37px;">' +
        '<span class="input-group-btn"  >' +
        '<button type="submit"  ng-click="ok()" class="btn btn-primary btn-sm"  style="background-color: #ffffff;border-color: rgb(193, 191, 191);padding: 0;border-left:none; height:37px;">' +
        '<img src="' + this.searchIcon + '" style="height: 100%;padding: 8px">' +
        '</button>' +
        '</span>' +
        '</form>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<br/><div class="col-md-12 p-l-1 p-r-1">' +
        '<div class="col-md-12 p-l-0 p-r-0">' +
        '<div ng-if="stores.length == 0 && noStoresFound" class="p-l-1 p-t-1"><b>No Stores Found! Please Try Again.</b> </div>' +
        ' <div style="max-height:441px; overflow-y: auto; overflow-x: hidden;"><div  ng-click="goToSignUp(store,store.storeURLName)" ng-class="( selectedStore == store.storeURLName ) ? selectedStoreClass : notSelectedClass " ng-repeat="store in stores" class="col-md-12 p-r-0 p-l-0 store-dt-div">' +
        '<div  class="row store-nm-div">' +
        '<div class="col-md-8 col-xs-8 p-r-0 p-l-1 " >{{$index + 1}}) {{store.city}}'+ 
        '<div class="col-md-12 store-add-div">{{store.addressLine1}}<br/> <span ng-if="store.addressLine2">{{store.addressLine2}}.<br/></span> {{store.city}}, {{store.state}}   {{store.zip}} <br /><span ng-if="store.phoneNumber">{{store.phoneNumber | telFormat}}<br/></span></div>'+
        '</div> ' +
        '<div class="col-md-4 col-xs-4 p-r-1 p-l-1 pull-right rt-align">' +
        '<button ng-click="goToSignUp(store, store.storeURLName)" type="button"  class="btn btn-primary btn-block-store-selector btn-sm-text mockup-btn sm-btn-bx">' +
        '<span  class="search-span">Shop Now</span>' +
        '</button>' +
        '</div>' +
        '</div>' +

        '</div> </div>' +
        '<div class="col-md-12 p-r-0 p-l-0 closest-div">' +
        '<div class="col-md-12 p-r-0 p-l-0">' +
        '<div ng-if="stores.length > 0 && selectStore" class="col-md-12 p-r-0 searchStoreText">' +
        '<a ng-click="loadMore()" ng-if="count < 15"><span class="search-span">+ view more store</span> </a>' +

        '</div>' +
        '</div>' +
        '</div>' +


              '</div>' +
              '</div>' +
              '</div>' +
              '<div class="col-md-9 hidden-sm-down" map-lazy-load="https://maps.google.com/maps/api/js?key=AIzaSyBMt42lgfunhhzqUsR0zT_rv4-LlMEKtoc">' +
              '<map center="[{{lat}},{{long}}]" zoom="{{zoom}}" style="display:block; width:auto; height:500px;"> ' +
              '<info-window id="storeInfo" max-width="200">' +
              '<div ng-non-bindable="">' +
              '<div class="scrollFix">' +
              '<div class="row">'+
              '<div class="col-md-8 col-xs-8 p-r-1 p-l-1" style="font-size: 0.9rem; font-weight: 300;font-weight: bold; padding: 0.5em 0.8em;" >{{storeIndex}}) {{storeObj.city}}'+ 
              '<div class="col-md-12 store-add-div">{{storeObj.addressLine1}}<br/> <span ng-if="storeObj.addressLine2">{{storeObj.addressLine2}}.<br/></span> {{storeObj.city}}, {{storeObj.state}}   {{storeObj.zip}} <br /><span ng-if="storeObj.phoneNumber">{{storeObj.phoneNumber | telFormat}}<br/></span></div>'+
              '</div>'+
              //  '<div class="col-xs-12 pb-4 font-weight-bold" style="color: #a4182d">Wild Birds Unlimited</div>'+
              //  '<div class="col-xs-12">'+
              //    '<div class="m-b-0">'+
              //    '<span class="font-weight-bold">{{storeObj.name}}</span><br />'+
              //    '<span>{{storeObj.addressLine1}}<br />'+
              //    '{{storeObj.city}},{{storeObj.state}}{{storeObj.country}}<br/>'+
              //    'Phone: {{storeObj.phoneNumber | telFormat}}</span><br />'+
              //    '<a href="mailto:{{storeObj.email}}" class="blue-colored">{{storeObj.email}}</a>'+
              //    '</div>'+
              //  '</div>'+
            '</div>'+
          '</div>'+
        '</div>'+
        '</info-window>' +
        '<marker id="{{pin.storeCode}}" on-click="showStoreInfo($index,pin)" ng-repeat="pin in stores" position="{{pin.lat}},{{pin.lng}}" icon="{{selectedStore == pin.storeURLName?higlightedmarkerIcon:markerIcon}}" title="{{pin.name}}"></marker>' +
        '</map>' +
        '</div>',
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService', '$state', '$stateParams', '$window', 'NgMap',
        function ($rootScope, $scope, $uibModalInstance, $auth, $state, $stateParams, $window, NgMap) {
          this.$state = $state;
          $scope.selectedStoreClass = "selectedStore";
          $scope.notSelectedClass = "";
          $scope.lat = '37.274053';
          $scope.long = '-103.535156';
          $scope.zoom = 4;
          $scope.count = 5;
          $scope.noStoresFound = false;
          $scope.stores = [];
          $scope.count = '';
          $scope.higlightedmarkerIcon = $ctrl.higlightedmarkerIcon;
          $scope.markerIcon = $ctrl.markerIcon;
          $scope.notMoreThanone = 0;
          
          NgMap.getMap()
            .then(map => {
              console.log('map', map);
              $scope.map = map;
            });
          $scope.showStoreInfo = (e,index, storeObj) => {
            $scope.changeStyle();
            $scope.selectedStore = storeObj.storeURLName;
            $scope.storeIndex = index+1;
            console.log('storeObj', storeObj);
            $scope.storeObj = storeObj;
            $scope.map.showInfoWindow('storeInfo', storeObj.storeCode);
          };
          $scope.ok = () => {
            //  $uibModalInstance.close();
            $scope.count = 5;
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": 5

            };
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              $scope.lat = $scope.stores[0].lat;
              $scope.long = $scope.stores[0].lng;
              $scope.zoom = 4;
              $scope.noStoresFound = false;
              console.log(success.data);
              if ($scope.stores.length == 0) {
                $scope.noStoresFound = true;
              }

              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            }, error => {
              $scope.noStoresFound = true;
            });
          };
          $scope.loadMore = () => {
            //  $uibModalInstance.close();
            if ($scope.count) {
              $scope.count = $scope.count + 5;
            } else {
              $scope.count = 10;
            }
            let data = {
              "searchKey": $scope.zipcode,
              "noOfStores": $scope.count

            };
            // if ($ctrl.storeName=='' || $ctrl.storeName == $ctrl.APP.ORDER.ORDER_URL.browseUrl) {
            //   data.isSEORequest = true;
            // }
            let stores = $auth.getStoresbyZipcode(data);
            stores.then(success => {
              $scope.stores = success.data;
              console.log(success.data);
              // this.test();
              // $state.go('signup', {
              //   storeName: 'indianapolis'
              // });
            });
          };
          $scope.cancel = () => {

            $uibModalInstance.close();
          };
          $scope.selectStore = (store, item) => {
            $scope.showStoreInfo(item, store);
            $scope.selectedStore = item;
            $scope.storeObj = store;
            $scope.lat = store.lat;
            $scope.long = store.lng;
          };

          // InfoWindow fix for googlemap
           $scope.changeStyle = () => {
            if ($scope.notMoreThanone < 2) {
              console.log("Inside if $scope.notMoreThanone", $scope.notMoreThanone);
              var selectorText = '.gm-style .gm-style-iw-c';
              var replace_infowindow = 'replace-infowindow';
              var arrow_selector = '.gm-style-iw-a::after';
              var replace_arrow_selector = 'replace_arrow_a::after';
              var theRules = [];
              for (var i = 0; i < document.styleSheets.length; i++) {
                try {
                  if (document.styleSheets[i].cssRules) {
                    for (var j = 0; j < document.styleSheets[i].cssRules.length; j++) {
                      if (document.styleSheets[i].cssRules[j].selectorText == selectorText
                        || document.styleSheets[i].cssRules[j].selectorText == replace_infowindow
                        || document.styleSheets[i].cssRules[j].selectorText == arrow_selector
                        || document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                        if (document.styleSheets[i].cssRules[j].selectorText == selectorText) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_infowindow;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_infowindow) {
                          document.styleSheets[i].cssRules[j].selectorText = selectorText;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = replace_arrow_selector;
                        }
                        else if (document.styleSheets[i].cssRules[j].selectorText == replace_arrow_selector) {
                          document.styleSheets[i].cssRules[j].selectorText = arrow_selector;
                        }
                      }
                    }
                  }
                } catch (e) {
                  // console.log("Some Error");
                }

              }
            } else {
              // console.log("Else part :");
            }
            $scope.notMoreThanone = $scope.notMoreThanone + 1;
          };

          $scope.goToProductPage = (store, item) => {
            console.log($stateParams);
            $stateParams.storeName = item;
            $window.location.href = '/' + $stateParams.storeName + '/' +
              $stateParams.categoryId + '/' + $stateParams.subCategoryId + '/' + $stateParams.productId;
            // $uibModalInstance.close();
            //  this.$state.go('signup', {
            //    storeName: item
            //  });
          };
          $scope.goToSignUp = (store, item) => {
            console.log($stateParams);
            // $stateParams.storeName = item;
            // $window.location.href = '/'+$stateParams.storeName + '/' +
            // $stateParams.categoryId + '/'+ $stateParams.subCategoryId + '/' + $stateParams.productId;

            $uibModalInstance.close();
            this.$state.go('signup', {
              storeName: item
            });
          };
          $scope.formatMobileNum = (num, format) => {
            
              var unFormattedNum = num;
              var position1 = 0;
              var position2 = 4;
              var position3 = 9;
              var qFormattedNum = [unFormattedNum.slice(0, position1), "(", unFormattedNum.slice(position1)].join('');
              var hFormattedNum = [qFormattedNum.slice(0, position2), ") ", qFormattedNum.slice(position2)].join('');
              var FormattedNum = [hFormattedNum.slice(0, position3), "-", hFormattedNum.slice(position3)].join('');
              return FormattedNum;
          };
        }
      ]

    });
  }

  sessionTimeout() {
    this.IDLE_TIMEOUT = 1800; // 1800; // seconds
    this.idleCounter = 0;
    document.onclick = () => this.idleCounter = 0;
    // document.onmousemove = () => this.idleCounter = 0;
    document.onkeypress = () => this.idleCounter = 0;
    this.stopCheckIdleTime = this.$interval(this.checkIdleTime, 1000);
  }


  checkIdleTime() {
    this.idleCounter++;
    // console.log('idleCounter', this.idleCounter);
    if (this.idleCounter >= this.IDLE_TIMEOUT) {
      this.askForLogout();
      this.$interval.cancel(this.stopCheckIdleTime);
    }
  }

  isStoreAvailabe() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if(storeName) {
      return storeName;
    }
    else {
      return '';
    }
  }

  goToRegister() {
    if(this.isStoreAvailabe()) {
    this.$window.location.href = '/signup/' + this.isStoreAvailabe(); 
    }
    else {
    this.openStoreSelector();
    }
  }
  goToLogin() {
    var storeName= '';
    console.log(this.$stateParams);
    // if(this.guestStore&&this.guestStore.storeName) {
    //   storeName = '/'+this.guestStore.storeName;
    // }
    // this.$window.location.href = '/login' + storeName;

    //
    if(this.guestStore&&this.guestStore.storeName) {
      storeName = this.guestStore.storeName;
    } 
    this.$state.go('login', {
      productId: this.$stateParams.productId,
      categoryId: this.$stateParams.categoryId,
      subCategoryId : this.$stateParams.subCategoryId,
      storeName: storeName
     });
    //  
  }
  askForLogout() {
    var $ctrl = this;
    this.$uibModal.open({
      sizede: 'sm',
      backdrop: false,
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">Your session will expire in one minute. Do you want to continue shopping?</h5>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="continueShopping()">Yes</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="logout()">No</button>' +
        '</div>',
      controller: ['$scope', '$rootScope', '$interval', 'authService', 'orderService', '$uibModalInstance',
        function ($scope, $rootScope, $interval, $auth, $order, $uibModalInstance) {
          const Timer = 60;
          var counter = 0;
          $scope.lastCheck = () => {
            counter++;
            // console.log('counter', counter);
            if (counter >= Timer) $scope.logout();
          };
          var stopLastCheck = $interval($scope.lastCheck, 1000);

          $scope.continueShopping = () => {
            $ctrl.sessionTimeout();
            $interval.cancel(stopLastCheck);
            $uibModalInstance.close();
          };

          $scope.logout = () => {
            $uibModalInstance.dismiss('cancel');
            $interval.cancel(stopLastCheck);
            $rootScope.$emit('closeSideNav');
            $auth.logout($ctrl.profile);
          };
        }
      ]
    });
  }

  getHeaderTitle(obj) {
    if (this.$window.innerWidth <= 0) {
      if (obj.current === 'home') {
        return this.profile.customer ? `Welcome ${this.profile.customer.firstName}` : 'Welcome';
      } else if (obj.current === 'sub-category') {
        return this.subCategories.length ? this.subCategories[0].category.name : 'Choose Category';
      } else if (obj.current === 'product') {
        return this.products.length ? this.products[0].itemList[0].subCategory.name : 'Choose Product';
      } else if (obj.current === 'product.detail') {
        return this.productDetail.name ? this.productDetail.name : 'Product Detail';
      } else {
        return obj.heading;
      }
    } else {
      return this.profile.customer ? `Welcome ${this.profile.customer.firstName}` : 'Welcome';
    }
  }

  getPrevState() {
    return this.navStates.filter(state => state.current === this.$state.current.name)[0];
  }

  goToPrevState() {
    this.$window.history.back();
  }

  search() {
    if(!this.searchTerm || this.searchTerm == '') {
      this.toaster.pop('success', 'Search text should not be empty');
      return;
    }
    this.$state.go('search', {
      storeName: this.profile.store.storeURLName,
      searchTerm: this.searchTerm
    });
  }

  openAside(position) {
    this.$rootScope.asideInstance = this.$aside.open({
      template: '<sidenav></sidenav>',
      placement: position,
      backdrop: true
    });
  }

  removeCart() {
    this.$uibModal.open({
      size: 'sm',
      template: '<div class="modal-body" id="modal-body">' +
        '<h5 class="font-weight-bold">Are you sure you want to remove all items in your cart?</h5>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
        '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()">Cancel</button>' +
        '</div>',
      controller: ['$scope', 'orderService', '$uibModalInstance', 'authService',
        function ($scope, $order, $uibModalInstance, $auth) {
          $scope.ok = () => {
            $order.removeCart()
              .then(() => {
                $order.getCartDetail();
                this.$rootScope.deliveryMode = null;
                $auth.getUserProfile();
              });
            $uibModalInstance.close();
          };
          $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        }
      ]
    });
  }

  isMobileOnly() {
    return this.$window.innerWidth < 543;
  }

  getDscPoints() {
    return Math.floor(this.profile.customer.totalPoints);
  }

  getDscExpireDate() {
    if (!this.profile.customer) return false;
    return new Date(this.profile.customer.dscExpireDate);
  }

  isDscMember(userData) {
    // console.log("userData--",userData)
    if(userData && userData.user && userData.user.customer) {
      if (!userData.user.customer) return false;
      return userData.user.customer.dscId === 'C' && new Date() <= new Date(userData.user.customer.dscExpireDate);
    } else {
      if (!this.profile.customer) return false;
      return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
    }
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  isRenewButtonToBeShown(){
    if (!this.profile.customer) return false;
    
    if(this.profile.customer.dscExpireDate){
      
     var d1 =  new Date(this.profile.customer.dscExpireDate);
     var renewCriteriadate = new Date(d1.setDate(d1.getDate()-45));
    
    //  console.log("Date: ", new Date());
      // console.log("!this.canUserJoin() ", !this.canUserJoin() );
      // console.log("renewCriteriadate", renewCriteriadate);
      // console.log("this.profile.customer.email", this.profile.customer.email);
      // console.log("renewCriteriadate<new Date()", renewCriteriadate<new Date());
      return !this.canUserJoin() && this.profile.customer.email && 
      (renewCriteriadate<new Date());
    }
   

     
  }

  logout() {
    this.$auth.logout();
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }
  selectedItem(item){
    // console.log(selectedItem);
  }

  goToNextState(item) {
    // console.log(item);
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } 
      else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      if(this.isMiscellaneousCategory(item))
      {
        this.goToGiftPage(storeName);
      }
      else {
        if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
          this.$state.go('browse-product', {
            categoryId: item.category.prettyUrl,
            subCategoryId: item.subCategoryList[0].prettyUrl,
            storeName: storeName
          });
        }
         else {
          // console.log('sc',item.category.id);
          this.$state.go('browse-sub-category', {
            categoryId: item.category.prettyUrl,
            storeName: storeName
          });
        }
      }
    }
     else {
      if(this.isMiscellaneousCategory(item))
      {
        this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
      }
      else {
        if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
          this.$state.go('browse-product', {
            categoryId: item.category.prettyUrl,
            subCategoryId: item.subCategoryList[0].prettyUrl,
            storeName: this.$auth.getGuestStoreDetail().storeName
          });
        }
         else {
          // console.log('sc',item.category.id);
          this.$state.go('browse-sub-category', {
            categoryId: item.category.prettyUrl, storeName: 'shop'
          });
        }
      }
    }
  }



  toggleHeader() {
    if (this.$auth.isLoggedIn()) {
      // console.log('logged in');
      this.$auth.getUserProfile();
      this.checkIdleTime = this.checkIdleTime.bind(this);
      this.sessionTimeout();
      this.templateUrl = 'menu.html';
      this.popoverTriggerOption = 'outsideClick';
      document.getElementById('headerAction').click();

    }


  }
  toggleHeaderGuest() {

    // this.checkIdleTime = this.checkIdleTime.bind(this);
    // this.sessionTimeout();
    this.checkIdleTime = this.checkIdleTime.bind(this);
    this.sessionTimeout();
    this.templateUrl = 'login.html';
    this.popoverTriggerOption = 'outsideClick';
    document.getElementById('headerAction').click();




  }
  goToCart() {
    if (this.$auth.isGuestLogin()) {
      if (this.profile.store && this.profile.store.hasGuestCheckout) {
        this.$state.go('guestcart', {'storeName': this.storeName});
      } else {
        var msg = 'access this';
        this.$auth.showLoginPopUp(msg);
      }
    } else {
      this.$state.go('cart');
    }

  }
  isLoggedIn() {
    return this.$location.path().indexOf('auth') === -1 &&
      this.$state.current.name !== 'login' &&
      this.$state.current.name !== 'signup';
  }

  guestLoginConfirmed() {
    if (this.$auth.isMobileDevice()) {
      this.$state.go('login', {
        'storeName': this.$auth.getGuestStoreDetail().storeName,
        productId: this.$stateParams.productId,
        categoryId: this.$stateParams.categoryId,
        subCategoryId : this.$stateParams.subCategoryId
      });
    } else {
      this.$timeout(() => {
        document.getElementById('headerAction').click();
      }, 100);
    }
  }

  getPromos(storeId) {
    this.$order.getPromoImage(storeId).then(() => {
      this.$rootScope.promo = this.promo;
      // if(this.isMobileOnly()){
      //   this.bannerSlider_Mob();
      // } else {
      //   this.bannerSlider();
      // }
      this.bannerSlider();
      
      this.$rootScope.$emit('rotateBanner');
      this.$rootScope.$emit('rotateMobileBanner');
    });
  }

  canUserJoin() {
    return ((!this.$auth.isLoggedIn()) || (!(this.isDscMember() || this.isDscButExpired())));

  }

  goToSavingsClub() {
    this.$state.go('savings-club', {
      'storeName': this.$auth.getGuestStoreDetail().storeName
    });
  }
  gotToHome() {
    if (this.profile.store.storeName) {
      this.$window.location.href = '/' + this.profile.store.storeName;
    } else {
      this.$window.location.href = '/';
    }
  }


  bannerSlider() {

    this.promosliderClass = "";
    
    if (this.promo) {
      this.promotionText = this.promo.promotionText[0];
      this.promosliderClass = "promotion-slider";
      this.$interval(() => {
        // console.log("Interval :",this.nextIndex," | ",new Date());
        this.nextIndex = (this.promo.promotionText.length - 1 == this.nextIndex) ? 0 : this.nextIndex + 1;
        this.promotionText = this.promo.promotionText[this.nextIndex];
        this.promosliderClass = "promotion-slider";

      }, 10000);
    }
  }
  
  bannerSlider_Mob() {

    this.promosliderClass = "";
    
    if (this.promo) {
      this.promotionText = this.promo.promotionText[0];
      this.promosliderClass = "promotion-slider";
      var i=0;
      var sliderDocElement = document.getElementById("promotion-slider");
      var testWidth = sliderDocElement.clientWidth;
      var finalTextWidth =  sliderDocElement.clientWidth;
      var defaultDelay = 10;
      var newDelay = 10;
      var text = this.promotionText;
      console.log("TestWidth : ", testWidth);
      var timeOutValue = 10;
      var setTimeForAnimeDuration = "10s";
      var $ctrl = this;
      var r = document.querySelector(':root');

//    Initial
      finalTextWidth = document.createElement("canvas").getContext("2d").measureText(text).width;

        if(finalTextWidth<testWidth) {
          newDelay = 10;
        } else {
          newDelay = defaultDelay*(finalTextWidth/testWidth);
        }

          setTimeForAnimeDuration = newDelay + "s";
          timeOutValue = newDelay * 1000;
          r.style.setProperty('--li-transform-animation-duration', setTimeForAnimeDuration);
          sliderDocElement.classList.remove("promotion-slider");
          void sliderDocElement.offsetWidth;
          sliderDocElement.classList.add("promotion-slider");
 
          sliderDocElement.innerHTML = "<span '>"+$ctrl.promotionText+"</span>";


      let timer = setTimeout(function promoDelay() {
        $ctrl.nextIndex = ($ctrl.promo.promotionText.length - 1 == $ctrl.nextIndex) ? 0 : $ctrl.nextIndex + 1;
        $ctrl.promotionText = $ctrl.promo.promotionText[$ctrl.nextIndex];
        text = $ctrl.promotionText;
        finalTextWidth = document.createElement("canvas").getContext("2d").measureText(text).width;

        if(finalTextWidth<testWidth) {
          newDelay = 10;
        } else {
          newDelay = defaultDelay*(finalTextWidth/testWidth);
        }

          setTimeForAnimeDuration = newDelay + "s";
          timeOutValue = newDelay * 1000;
          r.style.setProperty('--li-transform-animation-duration', setTimeForAnimeDuration);
         console.log("Text: "+ $ctrl.promotionText+ ", SetTimeForAnimeDuration : ", setTimeForAnimeDuration , ", TimeOutValue : ", timeOutValue);
         
         // To Reset the animation, remove and add same class, void offsetwidth is avoid some glitch
         // https://css-tricks.com/restart-css-animation/
         sliderDocElement.classList.remove("promotion-slider");
         void sliderDocElement.offsetWidth;
         sliderDocElement.classList.add("promotion-slider");

         sliderDocElement.innerHTML = "<span '>"+$ctrl.promotionText+"</span>";
         
         timer =  setTimeout(promoDelay, timeOutValue);
       },timeOutValue);

      /*
      this.$interval(() => {
        // console.log("Interval :",this.nextIndex," | ",new Date());
        this.nextIndex = (this.promo.promotionText.length - 1 == this.nextIndex) ? 0 : this.nextIndex + 1;
        this.promotionText = this.promo.promotionText[this.nextIndex];
        document.getElementById("promotion-slider").innerHTML = "<span  style='position: absolute;'>"+this.promotionText+"</span>";
        this.promosliderClass = "promotion-slider";

      }, 10000);
      */
    }
  }

  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  isMiscellaneousCategory(item){
    if(item){
      if(item.category.id === this.isMiscelleneousCategory){
        return true;
      } else {
        return false;
      }
    }
  }

  goToGiftPage(store) {
    this.$state.go('gift-card', {'storeName': store});
  }

  loginFromPopup(success) {
    console.log("Success loged in --- ", success);
    if(success.data && success.data.store && success.data.store.storeCode==this.APP.ORDER.CLOSED_STORE.storeCode) {
      this.$state.go('profile');
    } else {
      if (success.data.dscPop) {
        this.dscPopContent = success.data.dscPop;
        this.dscPopUp(success.data.dscPop,success);
      } else {
        this.loadFunction(success);
      }
    }
  }
  
  dscPopUp(dscPop,successData) {
    this.$rootScope.$emit('onLoginSuccess');
    this.dscPop = dscPop;
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      template: '<div class="static-content" style="background-color: #fff;">' +
        '<div class="row m-x-0 p-b-1 p-t-2">' +
        '<div class="col-xs-12">' +
        // '<h6 class="font-weight-bold mb-8">Daily Savings Club&reg; Exclusive Member Benefits</h6>'+
        '<div class="row">' +
        // '<span class="inline_block">'+
        // '<img img-lazy-loader={{dscCard}} alt="image" class="product-image" />'+
        // '</span>'+
        '<span class="inline_block">' +
        '<p ng-if="dscPop.dscExpired==0"> Your Daily Savings Club membership will expire in less than 30 days. Renew today so you don&apos;t miss any savings!</p>' +
        '<p ng-if="dscPop.dscExpired==1"> Your Daily Savings Club membership has expired. Renew today so you don&apos;t miss any savings! </p>' +
        // '<span>'+
        // '<span>Renew to add as a member of our Daily Savings Club®, for your annual membership fee of $25, you receive:</span>'+
        // '</span>'+
        '<div>' +
        '<span style="line-height: 13px;">' +
        '<span class="white-med-bold-text " style="display:inline-block">' +
        '<button  class="renew_dsc_button btn btn-primary detail-btn mockup-btn" ui-sref="savings-club" ng-click="cancel()">Renew</button>' +
        '</span>' +
        '</span>' +
        '<div style="line-height: 13px;float:right;">' +
        '<span class="white-med-bold-text " style="display:inline-block">' +
        '<button  style="width:100%" class="pull-xs-right renew_dsc_button btn btn-primary detail-btn mockup-btn" ng-click="ok()">No, Thanks</button>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '</span>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>',
      controller: ['$scope','$uibModalInstance',
        function ($scope, $uibModalInstance) {
          $scope.dscCard = dscCard;
          $scope.dscPop = dscPop;
          $scope.cancel = () => {
            $ctrl.userAction(this.APP.ORDER.USER_ACTION.RENEW_DSC_BUTTON);
            $uibModalInstance.close();
        };
          $scope.ok = () => {
            $uibModalInstance.close();
            $ctrl.loadFunction(successData);
          };
        }
      ]
    });
  }
  
  async loadFunction(success){
    const profile = success.data.user;
    this.$rootScope.$emit('FreeShipping',profile.store.storeName);
    let guestCartList = this.$auth.getGuestCart();
    let subscription = this.$auth.getSubscriptionId();
    sessionStorage.removeItem('guestoauth');
    sessionStorage.removeItem('isGuestUserLoggedIn');
    if (!profile.shippingAddressLine1 || !profile.shippingState ||
      !profile.shippingCity || !profile.shippingZipCode || !profile.shippingCountry || !profile.billingCountry ||
      !profile.billingAddressLine1 || !profile.billingState || !profile.billingCity || !profile.billingZipCode) {
      this.$auth.doGuestLogout();
      this.$rootScope.$emit('onLoginSuccess');
      this.toaster.pop('success', 'You need to complete your Profile');
      this.$state.go('profile.edit');
    }
    else if (subscription) {
      this.$auth.resetSubscriptionCart();
      this.$state.go('subscription-detail', { subscriptionId: subscription.id, option: 'edit' });
    }
    else {
      // If store not matched with guest login then redirect to home
      var store = this.$auth.getGuestStoreDetail();
      if (store.storeId != profile.store.storeId) {
        this.$auth.doGuestLogout();
        this.$auth.removeGuestCart();
        if (this.$stateParams.itemGroupNumber) {
          this.$state.go('browse-product.detail', {
            categoryId: this.$stateParams.categoryId, 
            subCategoryId: this.$stateParams.subCategoryId, 
            productId: this.$stateParams.productId,
            masterCode: this.$stateParams.itemGroupNumber,
            storeName: profile.store.storeURLName
           });
        } else if (this.$stateParams.productId) {
            this.$state.go('browse-product.detail', {
              categoryId: this.$stateParams.categoryId, 
              subCategoryId: this.$stateParams.subCategoryId, 
              productId: this.$stateParams.productId,
              storeName: profile.store.storeURLName
             });
        } else if (this.$stateParams.subCategoryId){
          this.$state.go('browse-product',{
            categoryId: this.$stateParams.categoryId, 
            subCategoryId: this.$stateParams.subCategoryId,
            storeName: profile.store.storeURLName 
          });
        } else if (this.$stateParams.categoryId){
          this.$state.go('browse-sub-category',{
            categoryId: this.$stateParams.categoryId, 
            storeName: profile.store.storeURLName 
          });
        } else {
          this.$state.go('category',{'storeName':profile.store.storeURLName});
        }
      }
      if (guestCartList && guestCartList.length) {
        this.$spinner.show('appSpinner');
        if (guestCartList.find(data => data.isDscCard)) {
          this.$window.scrollTo(0, 0);
          await this.$order.getCartDetail()
            .then(success => {
              this.detail = success.data;
              if (!this.isDscAddedinCart()) {
                console.log("Dsc item from guest gets added by addMultipleItemToCart function");
                // this.$order.buyDscMembership()
                //   .then(() => {
                //   });
              }
            })
            .catch(err => {
              // this.$order.buyDscMembership()
              //   .then(() => {
              //   });
            });
        } else if (guestCartList.find(data => data.isGiftCard)) {
          const guestCart = guestCartList.find(data => data.isGiftCard);
          this.$window.scrollTo(0, 0);
          await this.$order.getCartDetail()
            .then(success => {
              this.detail = success.data;
              this.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId)
                .then(() => {
                });
            })
            .catch(err => {
              this.$order.buyGiftCard(guestCart.quantity, guestCart.masterProductId)
                .then(() => {
                });
            });
        }
          const guestCartListFiltered = guestCartList.filter(guestItem => !guestItem.isGiftCard || !guestItem.isDscCard);
          await this.$order.addMultipleItemToCart({guestCartItems : guestCartListFiltered}).then();
          this.$spinner.hide('appSpinner');
          this.$auth.doGuestLogout();
          this.$auth.removeGuestCart();
          this.$rootScope.$emit('onLoginSuccess');
          this.$state.go('cart');
      } else {
        this.redirectUsertoStore(success.data);
        this.$auth.doGuestLogout();
        this.$auth.removeGuestCart();
        this.$rootScope.$emit('onLoginSuccess');
        if (this.$rootScope.inOrderPage) {
          this.$state.go('profile');
        }
      }
    }
  }

  isDscAddedinCart() {
    return this.detail.cartItems.some(function (cartItem) {
      return cartItem.item.storeItemCode === 'C';
    });
  }

  redirectUsertoStore(userData) {
    var $ctrl;
    $ctrl = this;
    console.log("--userData=--", userData);
    if (this.isDscMember(userData)) {
      if(this.$stateParams.productId) {
        if(userData && userData.store) {
        this.$window.location.href = '/'+userData.store.storeURLName+ '/' +
        this.$stateParams.categoryId + '/'+ this.$stateParams.subCategoryId + '/' + this.$stateParams.productId;
        } else {
          this.$window.location.href = '/'+ userData.store.storeURLName;
        }
      } else{
        this.$window.location.href = '/'+ userData.store.storeURLName;
      }
      return;
    } else {
      var isDsc = false;
      this.$auth.getAllStores().then(success => {
        angular.forEach(success.data, function (store) {
          if (store.dscId == 'C') {
            isDsc = true;
          }
        });
        if (isDsc) {
          this.$window.location.href = '/dashboard/profile/user';
        }
        else {
          return;
        }
      });
    }
  }

  userAction(userAction){
    this.$order.updateUserAction(userAction);
  }

  showA2HS() {
    console.log("--window.addToHomescreen--", window.addToHomescreen);
    if (window.addToHomescreen) {
      window.addToHomescreen();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/header/header.js